import { Link } from '@tanstack/react-router'
import { ArrowRight, Gauge, Lock } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { useMe } from '@/features/auth/api'
import { usePermission } from '@/hooks/use-permission'
import { useUpgradePrompt } from '@/stores/upgrade'

/** Global upgrade prompt for `quota-exceeded` / `feature-unavailable` problems. */
export function UpgradeDialog() {
  const { open, reason, title, detail, close } = useUpgradePrompt()
  const canBill = usePermission('billing.manage')
  const { data: me } = useMe()
  const Icon = reason === 'quota' ? Gauge : Lock
  return (
    <Dialog open={open} onOpenChange={(o) => !o && close()}>
      <DialogContent className="overflow-hidden p-0 sm:max-w-md">
        <div className="relative bg-brand-gradient px-6 pt-7 pb-6 text-white">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_80%_0%,rgba(255,255,255,0.25),transparent_55%)]" aria-hidden />
          <div className="relative flex size-11 items-center justify-center rounded-xl bg-white/15 ring-1 ring-white/25 backdrop-blur">
            <Icon className="size-5" />
          </div>
          <DialogHeader className="relative mt-4">
            <DialogTitle className="text-white">{title}</DialogTitle>
            <DialogDescription className="text-white/80">{detail}</DialogDescription>
          </DialogHeader>
        </div>
        <div className="px-6 pb-6">
          <p className="text-sm text-muted-foreground">
            {me?.subscription ? (
              <>
                You’re on the <span className="font-medium text-foreground">{me.subscription.plan.name}</span> plan.{' '}
              </>
            ) : null}
            {canBill ? 'Upgrade to raise your limits and unlock more features.' : 'Ask an organization owner to upgrade the plan.'}
          </p>
          <DialogFooter className="mt-5">
            <Button variant="outline" onClick={close}>
              Not now
            </Button>
            {canBill && (
              <Button variant="brand" asChild onClick={close}>
                <Link to="/settings/subscription" search={{ change: true }}>
                  Compare plans <ArrowRight />
                </Link>
              </Button>
            )}
          </DialogFooter>
        </div>
      </DialogContent>
    </Dialog>
  )
}
